import { Dispatch, SetStateAction, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { archiveForm as archiveFormService } from '../../../services/form/FormService';
import { unarchiveForm as unarchiveFormService } from '../../../services/form/FormService';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  archiveForm: (id: string, archive: boolean) => Promise<boolean>;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useArchiveForm = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);
  const intl = useIntl();
  const archiveForm = async (formId: string, archive: boolean): Promise<boolean> => {
    try {
      setIsLoading(true);
      let result;

      if (archive) {
        result = await archiveFormService(id, formId);
      } else {
        result = await unarchiveFormService(id, formId);
      }

      if (result.data === 1) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return false;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return false;
    }
  };

  return { archiveForm, isLoading, setOrganizationId };
};

export default useArchiveForm;
